var _circle, _circle2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 88,
    viewBox: "0 0 91 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#6D7A7C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0008,
    cy: 43.9998,
    r: 35.2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6165 43.7985C51.1587 42.2498 49.1464 41.2094 47.2355 40.3455C45.2456 39.4394 42.3628 38.7006 41.0959 36.7449C40.0331 35.1225 41.4975 33.4038 42.9896 32.9008C45.3918 32.0987 48.3549 33.0654 50.4633 34.252C51.5142 34.8459 52.6231 34.2625 53.0235 33.2116C53.4646 32.0474 53.9058 30.8885 54.3404 29.7243C54.6064 29.0118 54.1771 28.1071 53.545 27.7568C51.6288 26.6887 49.6323 26.1119 47.5239 25.8301V22.2691C47.5239 21.3248 46.7324 20.5333 45.7829 20.5333H42.4984C41.5542 20.5333 40.7574 21.3248 40.7574 22.2691V26.2462C37.5072 27.1852 34.5454 29.2818 33.3917 32.6058C32.109 36.2853 32.8887 40.0952 35.6187 42.8766C37.0831 44.3753 39.0612 45.3643 40.9392 46.2111C43.0581 47.1672 45.6644 47.856 47.0327 49.8973C48.4971 52.0781 46.6033 54.2327 44.5568 54.8543C41.8097 55.68 38.4804 54.4434 36.1731 53.0013C35.1617 52.3731 33.9857 53.0237 33.6183 54.0417L32.3461 57.5909C32.0748 58.3415 32.5265 59.1515 33.1481 59.5571C35.325 60.9767 37.8233 61.6879 40.3834 61.9829V65.7309C40.3834 66.234 40.5704 66.6251 40.847 66.907C40.8641 66.9254 40.8812 66.9412 40.8918 66.9583C40.9101 66.9717 40.9273 66.9867 40.9431 67.0031C41.2197 67.2796 41.6095 67.4667 42.1191 67.4667H45.4602C45.9191 67.4625 46.358 67.2785 46.6826 66.9542C47.0072 66.6298 47.1915 66.1911 47.196 65.7322V61.5891C50.8084 60.5501 53.6003 58.2204 55.0081 54.5922C56.4515 50.8968 55.2241 46.5891 52.6073 43.7972",
    fill: "url(#paint0_linear_276_28293)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2474 81.3334C81.9564 81.3334 88.2057 75.0841 88.2057 67.3751C88.2057 59.6661 81.9564 53.4167 74.2474 53.4167C66.5384 53.4167 60.2891 59.6661 60.2891 67.3751C60.2891 75.0841 66.5384 81.3334 74.2474 81.3334Z",
    fill: "url(#paint1_linear_276_28293)",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.552 72.9586C80.8798 71.7 81.7161 70.0098 81.9111 68.1908C82.1061 66.3717 81.6471 64.5426 80.6162 63.0312C79.5853 61.5198 78.0499 60.4249 76.2852 59.9425C74.5204 59.4601 72.6415 59.6219 70.9852 60.3988L72.0577 62.3293C72.8947 61.9655 73.8091 61.8157 74.7184 61.8935C75.6278 61.9712 76.5035 62.274 77.2666 62.7746C78.0298 63.2751 78.6563 63.9577 79.0899 64.7609C79.5234 65.564 79.7503 66.4623 79.75 67.375H76.45L79.552 72.9586ZM77.5148 74.3512L76.4423 72.4207C75.6053 72.7845 74.6909 72.9343 73.7816 72.8565C72.8722 72.7788 71.9965 72.476 71.2334 71.9754C70.4702 71.4749 69.8437 70.7922 69.4101 69.9891C68.9766 69.186 68.7497 68.2877 68.75 67.375H72.05L68.948 61.7914C67.6202 63.0499 66.7839 64.7402 66.5889 66.5592C66.3939 68.3783 66.8529 70.2074 67.8838 71.7188C68.9147 73.2302 70.4501 74.3251 72.2148 74.8075C73.9796 75.2899 75.8585 75.1281 77.5148 74.3512Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_276_28293",
    x1: 43.9434,
    y1: 20.5333,
    x2: 43.9434,
    y2: 67.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#F0802E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_276_28293",
    x1: 74.2474,
    y1: 55.9167,
    x2: 74.2474,
    y2: 78.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#F0802E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.32a9dc78248cfc77894ee87b7078a511.svg";
export { ForwardRef as ReactComponent };